import React from 'react';
import CloudIcon from '@material-ui/icons/FilterDramaRounded';
import StorageIcon from '@material-ui/icons/StorageRounded';
import LyricIcon from '@material-ui/icons/TextFieldsRounded';
import CoverIcon from '@material-ui/icons/ImageRounded';
import { withStyles, Grid, Typography, List, ListItem, ListItemText, ListItemIcon, } from '@material-ui/core';
import SolidBackdrop from '../misc/SolidBackdrop';
import FeatureBlock from '../misc/FeatureBlock';
import { green } from '@material-ui/core/colors';
import theme from '../../theme';
import Link from '../misc/Link';
import { trackEvent, AnalyticsConstants } from '../../../utilities/analyticsUtilities';

const styles = theme => ({
    section: {
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
        },
        [theme.breakpoints.up('md')]: {
            padding: `${theme.spacing(4) * 1.5}px 0`
        },
        marginTop: 0,
        marginBottom: 0,
        zIndex: 0
    },
    icon: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: `translate(-50%, -50%)`,
        fontSize: theme.typography.h3.fontSize,
        color: theme.palette.secondary.main
    },
    comingSoonText: {
        fontSize: '1.45rem',
        padding: theme.spacing(2)
    },
    comingSoonList: {
        width: 248,
    },
    comingSoonFeature: {
        fontWeight: 500
    }
});

class IndexCloudFeaturesSection extends React.Component {
	render() {
        const { classes } = this.props;
        
		return (
            <Grid
                container
                alignItems='flex-start'
                justify='center'
                spacing={10}
                className={classes.section}
            >
                <SolidBackdrop
                    image='https://specterr.b-cdn.net/bg-wave4.svg'
                    color={theme.palette.background.darker1}
                />
                <Grid 
                    item 
                    md={6}
                    xs={12}
                >
                    <FeatureBlock
                        color={green['A400']}
                        icon={<CloudIcon className={classes.icon}/>}
                        headline={'Fast Cloud Rendering'}
                        description={`
                            Our hardware accelerated machines perform all video rendering in the cloud. 
                            This means that when you hit 'export', our computer does the hard work instead of yours.
                            We designed our proprietary animation engine for speed and consistency.
                            It cuts export times from hours to minutes, and confirms that every export is flawless.
                        `}
                    />
                </Grid>
                <Grid 
                    item 
                    md={6}
                    xs={12}
                >
                    <FeatureBlock
                        color={green['A400']}
                        icon={<StorageIcon className={classes.icon}/>}
                        headline={'Unlimited Storage'}
                        description={`
                            Export as many videos as you want. 
                            We'll store each one so you can download them any time.
                            Video files can be large, but unlimited storage means less to worry about when backing up and transferring.
                            You can access your videos from anywhere, whenever you need them, with no limits on downloads.
                        `}
                    />
                </Grid>
            </Grid>
		);
	}
}

export default withStyles(styles)(IndexCloudFeaturesSection);